// class DetailsDisclosure extends HTMLElement {
//   constructor() {
//     super();
//     this.mainDetailsToggle = this.querySelector('details');
//     this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
//   }
//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     })
//   }
//   close() {
//     this.mainDetailsToggle.removeAttribute('open');
//     this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
//   }
// }
// customElements.define('details-disclosure', DetailsDisclosure);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summaryElement = this.querySelector('summary');
    this.leaveTimeout = null;

    this.isHeaderMenu = this.closest('header .list-menu > li');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));

    if (this.isHeaderMenu) {
      this.initHeaderHover();
      this.initHeaderClick();
    }
  }

  initHeaderHover() {
    // Open on mouse enter
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.leaveTimeout);
      this.open();
    });

    this.addEventListener('mouseleave', () => {
      this.leaveTimeout = setTimeout(() => {
        this.close();
      }, 150); 
    });
  }

  initHeaderClick() {
    this.summaryElement.addEventListener('click', (event) => {
      const url = this.summaryElement.getAttribute('data-url');
      if (url && url !== '#' && url !== '') {
        event.preventDefault(); 
        window.location.href = url;
      }
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summaryElement.setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summaryElement.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);